export default __webpack_public_path__ + "static/media/avatar_46.bf36457c.png";